import { SimplifiedDurationField } from "@/components/DurationFields";
import { SaveMeetingInput } from "@/api";

type MeetingLengthFieldProps = {
    updateFormData: (partialData: Partial<SaveMeetingInput>) => void;
    disabled?: boolean;
    formData: SaveMeetingInput;
};

export const MeetingLengthField = ({ updateFormData, disabled, formData }: MeetingLengthFieldProps) => {
    const valueMinutes = formData.length;

    const onChange = (v: any) => {
        updateFormData({ length: v });
    };

    return <SimplifiedDurationField value={valueMinutes} onChange={onChange} disabled={disabled} />;
};
